<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1y8NDv/tc-custom/9780547549194.jpg?1721404212945" alt="This image is the cover for the book Tao of Travel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tao of Travel
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The acclaimed author explores the greatest travel writing by literary adventurers from Freya Stark and James Baldwin to Nabokov and Hemmingway.</b></p><p>Paul Theroux celebrates fifty years of wandering the globe with this meditative journey through the books that shaped him as a reader and traveler. Part philosophical guide, part miscellany, part reminiscence, <i>The Tao of Travel</i> enumerates “The Contents of Some Travelers’ Bags” and exposes “Writers Who Wrote about Places They Never Visited”; tracks extreme journeys in “Travel as an Ordeal” and highlights some of “Travelers’ Favorite Places.” </p>Excerpts from the best of Theroux’s own work are interspersed with selections from travelers both familiar and unexpected, including J.R.R. Tolkien, Samuel Johnson, Eudora Welty, Evelyn Waugh, Isak Dinesen, Charles Dickens, Henry David Thoreau, Pico Iyer, Mark Twain, Anton Chekhov, Bruce Chatwin, John McPhee, Peter Matthiessen, Graham Greene, Paul Bowles, and many more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Theroux
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d560a5de